import { useAdminHook } from "@root/hooks/useAdminHook";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {};

const AdminContext = createContext<any>(defaultState);

interface AdminContextProviderProps {
  children: ReactNode;
}

export const AdminContextProvider: React.FC<AdminContextProviderProps> = ({
  children,
}) => {
  const data = useAdminHook();
  return <AdminContext.Provider value={data}>{children}</AdminContext.Provider>;
};

export const useAdminContext = () => {
  return useContext(AdminContext);
};
